import { useState } from "react";
import { useIsMobile } from "../../hooks/useIsMobile";
import { Plus } from "lucide-react";
import { Button } from "../../components/misc/Button";
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "../../components/misc/Card";
import FreeTrialForm from "./FreeTrailForm";
import FreeTrialList from "./FreeTrailList";

export default function AdminPromoCodesPage() {
    const [showForm, setShowForm] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const isMobile = useIsMobile(900);

    const handlePromoCodeCreated = () => {
        setShowForm(false);
        setRefreshTrigger((prev) => prev + 1);
    };

    return (
        <div className="min-h-screen bg-gray-50 py-8">
            <div className="container mx-auto px-4">
                <div className="max-w-6xl mx-auto space-y-6">
                    <div className={`flex ${isMobile ? "flex-col gap-4 items-start" : "justify-between items-center"}`}>
                        <div>
                            <h1 className="text-3xl font-bold text-primary">
                                Free Trial Code Management
                            </h1>
                            <p className="text-muted-foreground">
                                Create and manage free trial codes
                            </p>
                        </div>
                        <Button onClick={() => setShowForm(true)} className={isMobile ? "self-end" : ""}>
                            <Plus className="h-4 w-4 mr-2" />
                            Create a Free Trial Code
                        </Button>
                    </div>

                    {showForm && (
                        <Card>
                            <CardHeader>
                                <CardTitle>
                                    Create New Free Trial Code
                                </CardTitle>
                                <CardDescription>
                                    Create a new free trial code
                                </CardDescription>
                            </CardHeader>
                            <CardContent>
                                <FreeTrialForm
                                    onSuccess={handlePromoCodeCreated}
                                    onCancel={() => setShowForm(false)}
                                />
                            </CardContent>
                        </Card>
                    )}

                    <FreeTrialList key={refreshTrigger} />
                </div>
            </div>
        </div>
    );
}
